import { mapCategoryToSectionKey } from '../../utils/helper';

/**
 * Create initial section state for expandable sections
 * @param {Array} categories - Array of category objects
 * @param {boolean} defaultOpen - Whether sections should be open by default
 * @returns {Object} Initial state object with section keys as keys and defaultOpen as values
 */
export const createInitialSectionState = (categories, defaultOpen = false) => {
  if (!Array.isArray(categories)) {
    return {};
  }

  return categories.reduce((acc, category) => {
    const sectionKey = categoryToSectionKey(category);
    acc[sectionKey] = defaultOpen;
    return acc;
  }, {});
};

/** Stable section key: prefer `category.id` (e.g. fp-panel-0) like UserProfile, else name keywords. */
export const categoryToSectionKey = (category) => {
  if (category && category.id !== undefined && category.id !== null && String(category.id).trim() !== '') {
    return String(category.id);
  }
  return mapCategoryToSectionKey(category?.name);
};

/**
 * Extract numeric ID from category ID for sorting
 */
const extractCategoryNumber = (id) => {
  const match = String(id || '').match(/\d+/);
  return match ? parseInt(match[0], 10) : 999;
};

/**
 * Sort categories by numeric ID extracted from category.id
 */
export const sortCategoriesById = (categories) => {
  return [...categories].sort((a, b) => {
    return extractCategoryNumber(a.id) - extractCategoryNumber(b.id);
  });
};
